import main from './main';
import uiHooksBadge from './ui-hooks-badge';

export default function (server) {
  main(server);
  uiHooksBadge(server);
}
